<template>

    <div class="info-box">
        <div class="info-box__item info-box__alon">
            <div class="info-box__alon-inner">
                <div class="info-box__alon-text">
                    <h3 class="info-box__tit">본인 예약</h3>
                    <p class="info-box__desc">본인이 예약하실 경우 예약을 도와드립니다.</p>
                </div>
                <div class="info-box__alon-icon">
                    <img src="@/assets/resource/icon/point-icon01.svg" alt="">
                </div>
            </div>
            <div class="botton-wrap">
                <a href="" class="main-button c-main">본인예약하기</a>
            </div>
        </div>

        <div class="info-box__item info-box__agent">
            <div class="info-box__agent-inner">
                <h3 class="info-box__tit">본인 예약</h3>
                <p class="info-box__desc red">*최초 1회 실명인증 및 본인인증은 대리인 명의로 진행해주세요.</p>
                <div class="info-box__input">
                    <label><input type="text" placeholder="환자명"></label>
                    <label><input type="text" placeholder="환자 주민등록번호"></label>
                    <label><input type="text" placeholder="휴대전화번호"></label>
                </div>
            </div>
            <div class="botton-wrap">
                <a href="" class="main-button c-sub">대리인 예약하기</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
        },
    }
</script>